import React from "react";
import "./Button.scss";

export default function Button({text, className, href, newTab, onClick, rel}) {
  return (
    <div className={className}>
      <a
        className="main-button"
        href={href}
        target={newTab && "_blank"}
        rel={rel}
        onClick={onClick}
      >
        {text}
      </a>
    </div>
  );
}
